<div
  #cannabinoidColumn
  [style.visibility]="section?.collapseContent || rowVm.collapseContent ? 'collapse' : ''"
  [style.margin-right]="menu | productMenuBasicMethod: 'getSectionBorderMarginSize'"
  [style.white-space]="isThcAndCbdColumn ? 'pre-wrap' : null"
  [style.text-decoration]="productStylingVm | forcedColumnTextDecoration: colVm : locConfig | async"
  [ngStyle]="
    productStylingVm
      | lowAmountStyling
        : colVm
        : (productStylingVm | isLowAmountCannabinoidOrTAC: cannabinoidColumnType : !isOtherColumn)
      | async
  "
  class="product-column-general product-cannabinoid"
  [class.product-thc-and-cbd]="isThcAndCbdColumn"
  [class.product-low-amount]="
    productStylingVm | isLowAmountCannabinoidOrTAC: cannabinoidColumnType : !isOtherColumn | async
  ">
  <!-- ^ product-${cannabinoid} class gets added in the component ^ -->
  @if (isThcAndCbdColumn) {
    {{ rowVm | sectionRowViewModelBasicMethod: 'getThcAndCbd' }}
  } @else if (isTopCannabinoid) {
    <app-handle-badge-mode
      [colVm]="colVm"
      [rowVm]="rowVm"
      [nonListColumnBadgeAsset]="this | method: 'getNonListColumnItem'">
      {{ this | method: 'getNonListColumnItem' }}
    </app-handle-badge-mode>
  } @else if (isListCannabinoidColumn) {
    <app-column-list-items
      [colVm]="colVm"
      [rowVm]="rowVm"
      [displayFormat]="displayFormat"
      [sectionColumnType]="colVm.columnType"
      [columnListLayoutModifierClass]="columnListLayoutModifierClass"
      [parentColumnElement]="cannabinoidColumn">
    </app-column-list-items>
  } @else if (isOtherColumn) {
    <ng-container *ngIf="useNgContent"><ng-content></ng-content></ng-container>
    <ng-container *ngIf="!useNgContent">{{
      rowVm | sectionRowViewModelBasicMethod: 'getCannabinoid' : cannabinoidColumnType : displayFormat
    }}</ng-container>
  }
</div>
